export default {"src":"/_next/static/media/left-light-arrow.ee955b8e.svg","height":11,"width":12,"blurWidth":0,"blurHeight":0};